import { render, staticRenderFns } from "./SkeletonCompGeneralTopCard.vue?vue&type=template&id=2dd7bbe8"
import script from "./SkeletonCompGeneralTopCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonCompGeneralTopCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports